import { render } from "./PhaseCustodyResidentialDialog.vue?vue&type=template&id=8507018c&ts=true"
import script from "./PhaseCustodyResidentialDialog.vue?vue&type=script&lang=ts"
export * from "./PhaseCustodyResidentialDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__